import "../assets/Terms.css";
import { h as j, defineComponent as G, computed as f, ref as J, openBlock as n, createElementBlock as s, Fragment as U, renderList as V, createVNode as C, toDisplayString as i, createElementVNode as E, unref as y, createCommentVNode as b } from "vue";
import { T as Q, c as p } from "./maps.ChaVcqWI.js";
import { s as F, t as P } from "./useModal.CgbJKM9V.js";
import { o as W, m as X } from "./useStore.BHVfM1RP.js";
import { _ as x } from "./Checkbox.vue_vue_type_style_index_0_lang.BB_p1Ycv.js";
const A = (v, L) => {
  const t = "http://www.w3.org/2000/svg", u = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M5.917 5.833a.75.75 0 01.75-.75h7.5a.75.75 0 01.75.75v7.5a.75.75 0 01-1.5 0V7.644l-7.053 7.053a.75.75 0 11-1.061-1.06l7.053-7.054h-5.69a.75.75 0 01-.75-.75z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (v.title) {
    const c = document.createElementNS(t, "title");
    c.textContent = v.title, u.appendChild(c);
  }
  const m = Array.from((u == null ? void 0 : u.attributes) ?? []).reduce((c, _) => ({
    ...c,
    [_.name]: _.value
  }));
  return j(
    "svg",
    {
      ...m,
      ...L.attrs,
      role: "img",
      innerHTML: u.innerHTML
    }
  );
}, Z = {
  class: "thn--tool-terms",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "thn--tool-terms__label"
}, R = { key: 0 }, ee = ["for"], te = ["href"], le = ["onClick"], ne = {
  key: 4,
  class: "thn--tool-terms__label thn--tool-terms__label--tag"
}, se = ["for"], oe = ["innerHTML", "for"], re = ["href", "target"], ae = ["onClick"], ie = {
  key: 5,
  class: "thn--tool-terms__label thn--tool-terms__label--tag"
}, ge = /* @__PURE__ */ G({
  __name: "Terms",
  props: {
    customTerms: {},
    propertyTerms: {},
    termsInherited: { type: Boolean },
    termsRequired: { type: Boolean },
    disabled: { type: Boolean },
    appearanceStyle: {}
  },
  setup(v, { expose: L }) {
    const t = W(), T = v, u = f(() => {
      const e = (T.propertyTerms ?? []).map((l) => l.id);
      return (T.customTerms ?? []).filter((l) => !T.termsInherited || !e.includes(l.termId));
    }), m = J([]), c = f(
      () => {
        var e;
        return ((e = t == null ? void 0 : t.styles.fonts.formFieldName) == null ? void 0 : e.textTransform) === Q.Titlecase;
      }
    ), _ = f(() => t == null ? void 0 : t.literals.getLiteral("You must agree to the Terms & Conditions first")), w = t == null ? void 0 : t.literals.getLiteral("(Optional)"), M = f(() => t == null ? void 0 : t.literals.getLiteral("Terms_default_label", c.value)), O = f(() => t == null ? void 0 : t.literals.getLiteral("Terms_default"));
    function z() {
      const e = {
        valid: m.value.every((l) => l == null ? void 0 : l.validate()),
        terms: []
      };
      return e.valid && (e.terms = m.value.map((l) => ({
        termId: l.id,
        isChecked: l.isChecked
      }))), e;
    }
    function d(e) {
      var l, a;
      return e.content.languages ? c.value ? X(((l = e.content.languages[(t == null ? void 0 : t.literals.language) || "en"]) == null ? void 0 : l.label) || "") : (a = e.content.languages[(t == null ? void 0 : t.literals.language) || "en"]) == null ? void 0 : a.label : "";
    }
    function K(e) {
      var l, a;
      return (a = (l = e.content.languages) == null ? void 0 : l[(t == null ? void 0 : t.literals.language) || "en"]) == null ? void 0 : a.text;
    }
    function N(e) {
      var l, a;
      return (a = (l = e.content.languages) == null ? void 0 : l[(t == null ? void 0 : t.literals.language) || "en"]) == null ? void 0 : a.url;
    }
    function $(e) {
      return e.content.linkedTo === p.NotLinked;
    }
    function q(e) {
      return e.content.linkedTo === p.Url;
    }
    function Y(e) {
      return e.content.linkedTo === p.CustomUrl;
    }
    function B(e) {
      return [p.CustomText].includes(e.content.linkedTo);
    }
    function D(e) {
      return [p.DefaultText].includes(e.content.linkedTo);
    }
    function I(e) {
      F(K(e) || ""), P();
    }
    function S() {
      F(O.value || ""), P();
    }
    return L({
      validate: z
    }), (e, l) => {
      var a;
      return n(), s("div", Z, [
        e.termsInherited && ((a = e.propertyTerms) != null && a.length) ? (n(), s("div", R, [
          (n(!0), s(U, null, V(e.propertyTerms, (o, h) => (n(), s("div", {
            class: "thn--tool-terms__item",
            key: h
          }, [
            C(x, {
              ref_for: !0,
              ref: (r) => m.value[h] = r,
              "error-message": _.value,
              class: "thn--tool-terms__checkbox",
              disabled: !!e.disabled,
              required: e.termsRequired,
              name: "terms-inherit",
              id: o.id
            }, null, 8, ["error-message", "disabled", "required", "id"]),
            $(o) ? (n(), s("label", {
              key: 0,
              class: "thn--tool-terms__label",
              for: o.id
            }, i(d(o)), 9, ee)) : q(o) ? (n(), s("a", {
              key: 1,
              class: "thn--tool-terms__label thn--tool-terms__label--url",
              href: N(o),
              target: "terms-inherit"
            }, [
              E("span", null, i(d(o)), 1),
              C(y(A), {
                class: "thn--tool-terms__label--icon",
                "aria-hidden": "true"
              })
            ], 8, te)) : B(o) ? (n(), s("button", {
              key: 2,
              class: "thn--tool-terms__label thn--tool-terms__label--popup",
              onClick: (r) => I(o)
            }, i(d(o)), 9, le)) : D(o) ? (n(), s("button", {
              key: 3,
              class: "thn--tool-terms__label thn--tool-terms__label--popup",
              onClick: l[0] || (l[0] = (r) => S())
            }, i(M.value), 1)) : b("", !0),
            e.termsRequired ? b("", !0) : (n(), s("p", ne, i(y(w)), 1))
          ]))), 128))
        ])) : b("", !0),
        (n(!0), s(U, null, V(u.value, ({
          termId: o,
          isRequired: h,
          term: r
        }, g) => (n(), s("div", {
          key: g,
          class: "thn--tool-terms__item"
        }, [
          C(x, {
            ref_for: !0,
            ref: (k) => {
              var H;
              return e.termsInherited && ((H = e.propertyTerms) != null && H.length) ? m.value[g + e.propertyTerms.length] = k : m.value[g] = k;
            },
            "error-message": _.value,
            class: "thn--tool-terms__checkbox",
            disabled: !!e.disabled,
            required: h,
            name: `terms-${g}`,
            id: o
          }, null, 8, ["error-message", "disabled", "required", "name", "id"]),
          $(r) ? (n(), s("label", {
            key: 0,
            class: "thn--tool-terms__label",
            for: o
          }, i(d(r)), 9, se)) : Y(r) ? (n(), s("label", {
            key: 1,
            class: "thn--tool-terms__label thn--tool-terms__label--custom",
            innerHTML: r.content.htmlContent,
            for: o
          }, null, 8, oe)) : q(r) ? (n(), s("a", {
            key: 2,
            class: "thn--tool-terms__label thn--tool-terms__label--url",
            href: N(r),
            target: `terms-${g}`
          }, [
            E("span", null, i(d(r)), 1),
            C(y(A), {
              class: "thn--tool-terms__label--icon",
              "aria-hidden": "true"
            })
          ], 8, re)) : B(r) ? (n(), s("button", {
            key: 3,
            class: "thn--tool-terms__label thn--tool-terms__label--popup",
            onClick: (k) => I(r)
          }, i(d(r)), 9, ae)) : D(r) ? (n(), s("button", {
            key: 4,
            class: "thn--tool-terms__label thn--tool-terms__label--popup",
            onClick: l[1] || (l[1] = (k) => S())
          }, i(M.value), 1)) : b("", !0),
          h ? b("", !0) : (n(), s("p", ie, i(y(w)), 1))
        ]))), 128))
      ]);
    };
  }
});
export {
  ge as _
};
//# sourceMappingURL=Terms.vue_vue_type_style_index_0_lang.C0FpEuc5.js.map
